import { render } from "./MdNavigationItem.vue?vue&type=template&id=33198f02&scoped=true&ts=true"
import script from "./MdNavigationItem.vue?vue&type=script&lang=ts"
export * from "./MdNavigationItem.vue?vue&type=script&lang=ts"

import "./MdNavigationItem.vue?vue&type=style&index=0&id=33198f02&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33198f02"]])

export default __exports__